import { ContainerTurnoverDto } from '@billing/app/api'
import { ContainerTurnoversReportMode } from '@billing/app/models/container-turnovers-report-mode.enum'
import exportService from '@billing/services/ExportService'
import { action, computed, makeObservable, observable, runInAction } from 'mobx'
import {
  CTReportFieldsFormProfile,
  defaultValues,
} from '../forms/ct-report-fields-form/ct-report-fields-form.profile'

export class ContainerTurnoversUIStore {
  reportMode: ContainerTurnoversReportMode = ContainerTurnoversReportMode.Standard
  fieldsToExport: CTReportFieldsFormProfile = defaultValues

  turnovers: ContainerTurnoverDto[] = []
  isLoading = false

  constructor() {
    makeObservable(this, {
      reportMode: observable,
      fieldsToExport: observable,
      turnovers: observable,
      isLoading: observable,

      isDangerous: computed,
      isDamaged: computed,

      setReportMode: action,
      setFieldsToExport: action,
      fetchData: action,
      resetData: action,
    })
  }

  get isDangerous(): boolean | undefined {
    return this.reportMode === ContainerTurnoversReportMode.IMDG ? true : undefined
  }

  get isDamaged(): boolean | undefined {
    return this.reportMode === ContainerTurnoversReportMode.DAMAGED ? true : undefined
  }

  async fetchData(): Promise<void> {
    this.isLoading = true

    try {
      const data = await exportService.getContainerTurnoversData(this.isDangerous, this.isDamaged)

      runInAction(() => {
        this.turnovers = data
      })
    } catch (error) {
      console.error('Erro ao buscar dados de turnovers:', error)
      runInAction(() => {
        this.turnovers = []
      })
    } finally {
      runInAction(() => {
        this.isLoading = false
      })
    }
  }

  setReportMode(reportMode: ContainerTurnoversReportMode): void {
    this.reportMode = reportMode
  }

  setFieldsToExport(fieldsToExport: CTReportFieldsFormProfile) {
    this.fieldsToExport = fieldsToExport
  }

  public resetData(): void {
    this.reportMode = ContainerTurnoversReportMode.Standard
    this.fieldsToExport = defaultValues
    this.turnovers = []
    this.isLoading = false
  }
}
